import ICONS from 'components/common/icon/const'

const pomeloPickUpList = [
  {
    icon: ICONS.pickupLocation,
    title: {
      key: 'PDP__PICKUP_MODAL_STEP_1_TITLE',
      val: 'Add items and select location',
    },
    description: {
      key: 'PDP__PICKUP_MODAL_STEP_1',
      val: 'Confirm your order with mobile number and card details without paying upfront',
    },
  },
  {
    icon: ICONS.pickupNotification,
    title: {
      key: 'PDP__PICKUP_MODAL_STEP_2_TITLE',
      val: 'Receive notification',
    },
    description: {
      key: 'PDP__PICKUP_MODAL_STEP_2',
      val: 'We will notify you when the order is ready to try on at the location, usually takes 1-2 days',
    },
  },
  {
    icon: ICONS.pickupBag,
    title: {
      key: 'PDP__PICKUP_MODAL_STEP_3_TITLE',
      val: 'Try and pay later',
    },
    description: {
      key: 'PDP__PICKUP_MODAL_STEP_3',
      val: 'Reject unwanted items and pay at the Try On location for what you decide to keep',
    },
  },
]

export default pomeloPickUpList
